@use "variables" as *;

.container {
  cursor: pointer;
  display: flex;
}

.iconContainer {
  margin-left: $spacing-half;
  color: $content-secondary-color;
}
